export default async (cb, delay) => {
    return new Promise ((resolve)=>{
        setTimeout(()=>{
            resolve(cb());
        }, delay);
    });

};
